import { TableCell } from "@mui/material";
import { rolesWithPrivileges } from "./rolesWithPrivileges";
import { useSelector } from "react-redux";

export function checkUserAutherization(privilegeToBeChecked, user) {
	// const user = useSelector((state) => state.userInfo.userData);
	// const user = localStorage.getItem("user")
	// 	? JSON.parse(localStorage.getItem("user"))
	// 	: null;

	const userRoles = user ? user?.roles : [];
	let mergedPrivileges = [];

	userRoles?.forEach((role) => {
		const privileges = rolesWithPrivileges?.find(
			(r) =>
				r.role?.toLocaleLowerCase().trim() ===
				role?.toLocaleLowerCase().trim()
		)?.privileges;

		if (privileges) {
			mergedPrivileges = [
				...new Set([...mergedPrivileges, ...privileges]),
			];
		}
	});
	return mergedPrivileges.includes(privilegeToBeChecked);
}

export const CustomTableRow = ({ ReportMstId, column, path, ...props }) => {
	const user = useSelector((state) => state.userInfo.userData);
	return (
		<TableCell {...props}>
			<a
				href={
					path ? path :
					column.id !== "actionBtnName" &&
					column.id !== "download" &&
					column.id !== "mrt-row-expand" &&
					`${window.location.href}/${ReportMstId}`
				}
			>
				{props.children}
			</a>
		</TableCell>
	);
};
